
function setMainElementMinHeight() {
  const header = document.querySelector('header');

  if (!header) {
    return;
  }

  const headerHeight = header.offsetHeight;
  const footerHeight = document.querySelector('footer').offsetHeight;
  const totalHeight = headerHeight + footerHeight;

  document.querySelector('main').style.minHeight = 'calc(100% - ' + totalHeight + 'px)';
}

function setMobileMenuMinHeight() {
  const navbar = document.querySelector('header .navbar');

  if (!navbar) {
    return;
  }

  const navbarHeight = navbar.offsetHeight;

  document.querySelector('.mobile-menu').style.height = `calc(100vh - ${navbarHeight}px)`;
}

function updateFooterPaddingForApplyButtonOnMobile() {
  const applyBtnContainer = document.querySelector('.job-inner-btn-float');
  const footerElement = document.querySelector('footer');

  // Exit early if either element is missing
  if (!applyBtnContainer || !footerElement) return;

  footerElement.style.paddingBottom = '0px';

  // Check if the screen width is mobile size (typically 992px or less)
  const isMobile = window.innerWidth <= 992;
  if (!isMobile) return;

  // Dynamically calculate and set the footer's bottom margin
  const applyBtnContainerHeight = applyBtnContainer.offsetHeight;
  footerElement.style.paddingBottom = `${applyBtnContainerHeight}px`;
}

setMainElementMinHeight();
setMobileMenuMinHeight();
updateFooterPaddingForApplyButtonOnMobile();

$(() => {
  $(window).resize(function () {
    setMainElementMinHeight();
    setMobileMenuMinHeight();
    updateFooterPaddingForApplyButtonOnMobile();
  });
});
